import store from '@/store';

function changeUserLanguage(language) {
  return store.dispatch('user/changeUserLanguage', language);
}

export default {
  changeUserLanguage,
};
